import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DataStore, Predicates}                                                               from 'aws-amplify';
import {Bonus, BonusType, Contract, Faq, PermissionType, SupportRequest, Team, Ticket, User} from '../../../models';
import {DomSanitizer}                                                                        from '@angular/platform-browser';
import {ContractStatus, FaqCategory, Roles} from '../../enums/enums';
import {AgentService} from '../../services/agent.service';
import {APIService} from '../../API.service';
import {HttpClient} from '@angular/common/http';
import {SortDirection} from '@aws-amplify/datastore';
import {DateTime} from "luxon";
import {BonusServiceService} from "../../services/bonus-service.service";

@Component({
    selector: 'app-administrator-home-menu',
    templateUrl: './administrator-home-menu.component.html',
    styleUrls: ['./administrator-home-menu.component.scss'],
})
export class AdministratorHomeMenuComponent implements OnInit {
    sortDirection = SortDirection.ASCENDING;
    page = 1;
    cssClass: any;
    downloadJsonHref: any;

    constructor(
        private router: Router,
        private sanitizer: DomSanitizer,
        private agentService: AgentService,
        private apiService: APIService,
        private http: HttpClient,
        private bonusService: BonusServiceService,
    ) {
    }

    ngOnInit() {
    }

    openPage(page: string) {
        return this.router.navigate([page]);
    }

    subsectionClicked(page: number) {
        this.page = page;
    }

    stringToBoolean = (string) => string === 'false' ? false : !!string;

    backClicked() {
        this.page = 1;
    }

    async downloadJson() {
        console.log('inizio');

        let users = await DataStore.query(User, Predicates.ALL, {
            sort: s => s.lastname(this.sortDirection).name(this.sortDirection),
        });
        let contracts = await DataStore.query(Contract);


        var theJSON = JSON.stringify({users, contracts});
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/json;charset=UTF-8,' + encodeURIComponent(theJSON));
        element.setAttribute('downloyad', 'primer-server-task.json');
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click(); // simulate click
        document.body.removeChild(element);/*
        var uri = this.sanitizer.sanitize(SecurityContext.URL, 'data:text/json;charset=UTF-8,' + encodeURIComponent(theJSON));
        console.log(uri);
        console.log('fatto');
        this.downloadJsonHref = uri;*/
    }

    async resetCommerciali() {
        let users = await DataStore.query(User, condition => condition.permessions('ne', PermissionType.CLIENT));
        for (let user of users) {
            await DataStore.save(User.copyOf(user, up => {
                up.role = 'Excutive Advisor';
                up.totalActiveContracts = 0;
            }));
        }

    }

    async resetContratti() {

        let users = await DataStore.query(Contract, c => c.startDate('contains', '2021'));
        users.forEach(async u => {
            await DataStore.save(Contract.copyOf(u, up => {
                up.status = ContractStatus.TOBEPAYED;
            }));
        });


    }

    async attivaContratti() {
        let monthes = {
            '1': 'Gennaio',
            '2': 'Febbraio',
            '3': 'Marzo',
            '4': 'Aprile',
            '5': 'Maggio',
            '6': 'Giugno',
            '7': 'Luglio',
            '8': 'Agosto',
            '9': 'Settembre',
            '10': 'ottobre',
            '11': 'Novembre',
            '12': 'Dicemebre',
        };
//        let contracts = await DataStore.query(Contract, c => c.status('ne', ContractStatus.ACTIVE).startDate('contains', '2021'));


        let users = await DataStore.query(User, condition => condition.permessions('ne', PermissionType.CLIENT));
        for (let i = 1; i < 13; i++) {
            let date = DateTime.now().set({month: i, year: 2021}).startOf('month');
            let startDate = date.toISODate();
            let endDate = date.endOf("month").toISODate();
            let contractsToActive = (await DataStore.query(Contract, condition => condition.startDate('ge', startDate).status('ne', ContractStatus.ACTIVE).startDate('le', endDate),{
                sort:s=>s.startDate(SortDirection.ASCENDING)
            }))

            for (let c of contractsToActive) {
                await this.agentService.activeContract(c);
            }

            console.log("---------start------------");
            console.log(monthes[i.toString()]);
            console.log(startDate,endDate);
            console.log("---------------------");
            for (const user of users) {
                let b3 = await this.bonusService.calculateAllBonus(startDate, endDate, BonusType.BONUS_TEAM_3, user.id);
                if (b3 != 0) {
                    let x = await DataStore.save(new Bonus({
                        user: user,
                        total: b3,
                        date: endDate,
                        payDate: date.plus({month: 3}).toISODate(),
                        typeEnum: BonusType.BONUS_TEAM_3,
                        info: "3.team Bonus: " + monthes[i.toString()],
                    }));
                    console.log("3.team Bonus: ", user.lastname, b3);
                } else {
                    console.log("3.team Bonus: ", user.lastname, "NESSUN BONUS");
                }

                if (i % 3 == 0) {
                   let startDate3 = date.plus({month: -2}).startOf('month').toISODate();
                   let endDate3 = date.endOf('month').toISODate();


                    let b4 = await this.bonusService.calculateAllBonus(startDate3, endDate3, BonusType.REVENUE_BONUS_4, user.id);

                    if (b4 != 0) {
                        let x = await DataStore.save(new Bonus({
                            user: user,
                            total: b4,
                            date: endDate,
                            payDate: date.plus({month: 1}).toISODate(),
                            typeEnum: BonusType.REVENUE_BONUS_4,
                            info: "4.Revenue Bonus: " + monthes[i.toString()],
                        }));
                        console.log("4.Revenue Bonus: ", user.lastname, b4);
                    } else {
                        console.log("4.Revenue Bonus: ", user.lastname, "NESSUN BONUS");
                    }

                    let b5 = await this.bonusService.calculateAllBonus(startDate3, endDate3, BonusType.SPONSOR_BONUS_5, user.id);

                    if (b5 >= 1) {
                        let x = await DataStore.save(new Bonus({
                            user: user,
                            total: b5,
                            date: endDate,
                            payDate: date.plus({month: 2}).toISODate(),
                            typeEnum: BonusType.SPONSOR_BONUS_5,
                            info: "5.Sponser Bonus: " + monthes[i.toString()],
                        }));
                        console.log("5.Sponser Bonus: ", user.lastname, b5);
                    } else {
                        console.log("5.Sponser Bonus: ", user.lastname, "NESSUN BONUS");
                    }


                    let b6: Bonus[] = await this.bonusService.calculateAllBonus(startDate3, endDate3, BonusType.MANAGER_BONUS_6, user.id);

                    if (b6.length > 0) {
                        for (let bonus6 of b6) {
                            await DataStore.save(bonus6);
                        }
                        console.log("6.Manager Bonus: ", user.lastname, b6);
                    } else {
                        console.log("6.Manager Bonus: ", user.lastname, "NESSUN BONUS");
                    }
                }


                if (i % 12 == 0) {
                 let   startDateAnnuale = date.startOf('year').toISODate();
                  let  endDateAnnuale = date.endOf('year').toISODate();
                    let b7 = await this.bonusService.calculateAllBonus(startDateAnnuale, endDateAnnuale, BonusType.AMBASSADOR_BONUS_7, user.id);

                    if (b7 != 0) {
                        let x = await DataStore.save(new Bonus({
                            user: user,
                            total: b7,
                            date: endDate,
                            payDate: date.plus({month: 2}).toISODate(),
                            typeEnum: BonusType.SPONSOR_BONUS_5,
                            info: "7.Ambassador Bonus: " + monthes[i.toString()],
                        }));
                        console.log("7.Ambassador Bonus: ", user.lastname, b7);
                    } else {
                        console.log("7.Ambassador Bonus: ", user.lastname, "NESSUN BONUS");
                    }
                }

            }


            console.log("---------end------------");
            console.log(monthes[i.toString()]);
            console.log("---------------------");
        }


        //this.agentService.activeContract();

    }

    async calcolaPianoCariera() {
        let utenti = await DataStore.query(User, u => u.permessions('ne', PermissionType.CLIENT));

        for await (const u of utenti) {


            let amount = 0;
            let contratti = (await DataStore.query(Contract, c => c.startDate('contains', '2020'))).filter(value => value.commercial?.id == u.id);
            for (const c of contratti) {


                amount = amount + c.amount;
                await DataStore.save(Contract.copyOf(c, cUpdated => {
                    cUpdated.status = ContractStatus.ACTIVE;
                }));
            }
            const roles = Object.values(Roles);
            const eligibleRoles = roles.filter(r => r.capital <= amount);
            const agentNewRole = eligibleRoles[eligibleRoles.length - 1];
            console.log(u.name + ' ' + u.lastname, amount, agentNewRole, contratti);
            let x = await DataStore.save(User.copyOf(u, updated => {
                updated.role = agentNewRole.displayName;
                updated.totalActiveContracts = amount;
            }));
            console.log(x);

        }
    }

    async deleteBonus() {
        await DataStore.delete(Bonus, Predicates.ALL);
    }

    t;

    async importDati() {
        console.log(await DataStore.query(User));
        // @ts-ignore
        let utenti: [{
            id: string;
            __typename: string;
            _lastChangedAt: number;
            _version: number;
            addedBy: string;
            cf?: any;
            createdAt: Date;
            email: string;
            FcartaIdentita: string;
            FprovaResidenzaAutenticata: string;
            lastname: string;
            name: string;
            notes?: any;
            numeroCI?: any;
            permessions: string;
            phoneNumber?: any;
            role: string;
            teamID: string;
            TRC20?: any;
            TRC20Active: string;
            updatedAt: Date;
        }]
            = await this.http.get('./assets/users.json').toPromise();
        // @ts-ignore
        let contratti:
            [{
                id: string;
                __typename: string;
                _lastChangedAt: number;
                _version: number;
                amount: number;
                bonusActiveFirstYear: number;
                bonusRecurrence: string;
                contractAddedById: string;
                contractClientId: string;
                createdAt: Date;
                date: string;
                durationInDays?: any;
                endDate: string;
                extended: boolean;
                extendedBy: string;
                extendedFromDate: string;
                extendedTimeStamp: Date;
                file?: any;
                notes?: any;
                percent: number;
                product: string;
                startDate: string;
                status: string;
                updatedAt: Date;
                userID: string;
            }
            ]
            = await this.http.get('./assets/contracts.json').toPromise();

        console.log('utenti', utenti);
        console.log('x', contratti);

        let teamid = (await DataStore.query(Team))[0]?.id;
        let arrayUtenti = [];
        for (let user of utenti) {

            let x = await DataStore.query(User, x => x.email('eq', user.email));
            arrayUtenti[user.id] = x[0];
            /*if (x) {
                let u = await DataStore.save(User.copyOf(x,
                    updat => {
                        updat.TRC20 = user.TRC20;
                        updat.addedBy = user.addedBy;
                        updat.email = user.email;
                        updat.lastname = user.lastname;
                        updat.name = user.name;
                        updat.notes = user.notes;
                        updat.numeroCI = user.numeroCI;
                        // @ts-ignore
                        updat.permessions = user.permessions;
                        updat.phoneNumber = user.phoneNumber;
                        updat.role = user.role;
                        updat.teamID = teamid;

                    }));
                arrayUtenti[index]['userDatastore'] = u;
                console.log('userAggiornato:');
            } else {


                let x = new User({
                    TRC20: user.TRC20,
                    addedBy: user.addedBy,
                    email: user.email,
                    lastname: user.lastname,
                    name: user.name,
                    notes: user.notes,
                    numeroCI: user.numeroCI,
                    // @ts-ignore
                    permessions: user.permessions,
                    phoneNumber: user.phoneNumber,
                    role: user.role,
                    teamID: teamid,
                });
                let u = DataStore.save(x);
                arrayUtenti[index]['userDatastore'] = u;


            }*/


        }
        ;


        for (let utente of utenti) {
            let f = contratti.filter(x => x.contractAddedById == utente.id);
            for (let contratto of f) {
                try {
                    // @ts-ignore
                    let x = arrayUtenti[utente.id];
                    let utenteId = x.id;

                    let utenteLocId = (utenti.find(l => l.id == contratto.contractClientId)).id;
                    console.log('-----------------------------');
                    console.log('prima di creazione', utenteLocId, utenteId, f);
                    console.log('-----------------------------');
                    console.log('-----------------------------');
                    console.log('-----------------------------');

                    let c = new Contract({
                        notes: contratto.notes,
                        amount: contratto.amount,
                        status: contratto.status,
                        // @ts-ignore
                        userContractsAddedId: utenteId,
                        durationInDays: contratto.durationInDays,
                        // @ts-ignore
                        bonusActiveFirstYear: parseFloat(contratto.bonusActiveFirstYear),
                        date: contratto.date,
                        // @ts-ignore
                        bonusRecurrence: parseFloat(contratto.bonusRecurrence),
                        endDate: contratto.endDate == '' ? '2020-01-15' : contratto.endDate,
                        product: contratto.product,
                        startDate: contratto.startDate,
                        extended: this.stringToBoolean(contratto.extended),
                        extendedBy: contratto.extendedBy,
                        percent: contratto.percent,
                        // @ts-ignore
                        clientId: arrayUtenti[utenteLocId].id,
                    });
                    await DataStore.save(c);


                } catch (e) {
                    console.log('++++++++++++++++++++++++++++++++++');
                    console.log('utenteErrore', utente, contratto);
                    console.log(e);
                    console.log('++++++++++++++++++++++++++++++++++');

                    return;
                }


            }


        }
        console.log(await DataStore.query(Contract));
        return;
        /* let y: any = [];
         for (let n of x) {

             let u: CreateUserInput = {
                 FcartaIdentita: undefined,
                 FcartaIdentitaAutenticata: undefined,
                 FcontrattoInvestimento: undefined,
                 FcurricolumVitae: undefined,
                 FdeclarationIndividual: undefined,
                 Fextra1: undefined,
                 Fextra2: undefined,
                 FprofessionalReference: undefined,
                 FprovaResidednza: undefined,
                 FprovaResidenzaAutenticata: undefined,
                 FsowForm: undefined,
                 TRC20: '',
                 TRC20Active: false,
                 _version: 0,
                 addedBy: '',
                 assignedTo: '',
                 cf: '',
                 device_id: '',
                 directExcutiveBonus: false,
                 directLeaderBonus: false,
                 directSeniorBonus: false,
                 downlineExcutiveBonus: false,
                 downlineLeaderBonus: false,
                 downlineSeniorBonus: false,
                 email: '',
                 id: '',
                 lastname: '',
                 name: '',
                 notes: '',
                 numeroCI: '',
                 oneSignalEmailId: '',
                 permessions: undefined,
                 phoneNumber: '',
                 role: '',
                 teamID: ''
             }
             y.push(u);
         }
         console.log(y);
         for (let nn of y) {
             await this.dataService.apiService.CreateService(nn);
         }*/

    }



    async setAndre() {
        let toreplace = 'be7ccc14-3c06-4049-a440-05fd402b5804';
        let replace = '98589751-cad1-430d-8e03-918f7a2b89f8';
        let users = await DataStore.query(User);
        for (let u of users) {
            if (u.addedBy == toreplace) {
                await DataStore.save(User.copyOf(u, updated => {
                    updated.addedBy = replace;
                }));
            }
        }
        let userToChangeContracts = await DataStore.query(User, l => l.addedBy('eq', replace));
        let commercial = await DataStore.query(User, replace);
        for (let ucc of userToChangeContracts) {
            let contracts = await DataStore.query(Contract, condition => condition.clientId('eq', ucc.id));
            for (let c of contracts) {

                await DataStore.save(Contract.copyOf(c, updated => {
                    updated.commercial = commercial;
                }));

            }
        }
        //let contracts = await DataStore.query(Contract, condition => condition);

    }

    async setEmails() {
        let users = await DataStore.query(User);
        for (let user of users) {
            let x = await DataStore.save(User.copyOf(user, up => {
                up.email = up.email.toLowerCase().trimEnd();
                up.name = up.name?.toLowerCase()?.trim();
                up.lastname = up.lastname?.toLowerCase()?.trim();
            }));
        }
    }

    async changeProducts() {
        let contr = await DataStore.query(Contract, x => x.product('eq', 'sh'));
        contr.forEach(x => {
            DataStore.save(Contract.copyOf(x, y => {
                y.product = "Shield";
            }));
        });
        console.log(contr);
    }

  async  noCommercialContracts() {
        let x = await DataStore.query(Contract);
        let noC = [];
      for (const c of x) {
          if (c.commercial == null)
          {
              let client = await DataStore.query(User,c.clientId);
              let m ={
                  c:c,
                  client:client
              }
              noC.push(m);
          }

      }
      console.log(noC)


    }

  async  noClientContract() {
      let x = await DataStore.query(Contract);
      let noC = [];
      for (const c of x) {

           let client =    await DataStore.query(User,c.clientId);
           if (client == null){
               noC.push(c);
           }
      }
      console.log(noC)


  }

  async  setNomi() {
        await DataStore.delete(Ticket,Predicates.ALL);
        await DataStore.delete(SupportRequest,Predicates.ALL);
      return;
        let users = await DataStore.query(User,Predicates.ALL,{
            sort: s=> s.lastname(SortDirection.ASCENDING).name(SortDirection.ASCENDING)
        });
      console.log(users);
        for (const u of users){
            let l,n;
            if (u.lastname != null){
                l= u.lastname?.trim()?.toLowerCase();
            }else{
                l = " ";
            }
            if (u.name != null){
                n=u.name?.trim()?.toLowerCase();
            }else {
                n=" ";
            }

            await DataStore.save(User.copyOf(u,d=>{
                d.lastname = l
                d.name = n
            }))

        }
    }
}

